import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
export function OfferSection() {
  return <section id="comprar" className="bg-sand py-12 sm:py-16" data-id="element-141" data-mp="3lzio6gmatbe">
      <div className="mx-auto max-w-2xl px-5" data-id="element-142" data-mp="8lu783cx76ta">
        <div className="rounded-3xl border border-stone bg-ivory p-6 text-center shadow-[0_30px_70px_-45px_rgba(28,27,25,0.4)] sm:p-9" data-id="element-143" data-mp="ddvetbz589cz">
          <h2 className="font-display text-2xl font-semibold leading-tight text-charcoal sm:text-3xl" data-id="element-144" data-mp="ic6rrvkqizzf">
            El sistema completo, en un solo pago
          </h2>
          <p className="mt-2 font-sans text-sm font-semibold text-charcoal/75 sm:text-base" data-id="element-145" data-mp="re68emru821u">
            6 tomos + 5 bonos de implementación
          </p>

          <PriceBlock className="mt-5" size="lg" data-id="element-146" data-mp="wc7znuzf37oe" />

          <p className="mx-auto mt-4 max-w-sm font-sans text-[0.78rem] leading-relaxed text-charcoal/60" data-id="element-147" data-mp="2t5szeobqbwyb">
            El sistema completo cuesta menos que el valor que puede representar un solo alumno o
            cliente nuevo.
          </p>

          <div className="mt-5 flex justify-center" data-id="element-148" data-mp="12otenehhl7hf">
            <CTAButton className="w-full max-w-[24rem] px-5" data-id="element-149" data-mp="xwa4yslx6whw" />
          </div>

          <p className="mt-2.5 font-sans text-[0.72rem] text-charcoal/60" data-id="element-150" data-mp="sxp3kpuxm6rv">
            Acceso inmediato. Empezá a aplicarlo hoy.
          </p>
          <p className="mt-1 font-sans text-[0.7rem] text-charcoal/50" data-id="element-151" data-mp="oxeuv5fr929b">
            Garantía 7 días · Pago seguro
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 border-t border-stone pt-4 font-sans text-[0.7rem] text-charcoal/55" data-id="element-152" data-mp="1lka2qchnfn5z">
            <span className="inline-flex items-center gap-1" data-id="element-153" data-mp="1ckn23swquldz">
              <CheckIcon className="h-3.5 w-3.5 text-gold-deep" aria-hidden data-id="element-154" data-mp="17mlf4ww761x8" /> 100% digital
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-155" data-mp="169dglu621ww">💳 Mercado Pago</span>
            <span className="inline-flex items-center gap-1" data-id="element-156" data-mp="3scu1rxsu6vq8">🏦 Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}